/**
 * Home JS
 */

import styles from '../scss/home.scss';
import $ from 'jquery';

const $window = $(window);
const $scroll = $('.hero-scroll');
const $hero = $('.hero-home');

const opacityStart = 1;
const opacityEnd = 0;

const scaleStart = 1;
const scaleEnd = 1;

const translateStart = 0;
const translateEnd = 60;

$(window).scroll(() => {
  let scaler = 1 - ($window.scrollTop() - $hero.offset().top) / $hero.height();

  if (scaler > 1) {
    scaler = 1;
  } else if (scaler < 0) {
    scaler = 0;
  }

  $scroll
    .css('opacity', scaler * (opacityStart - opacityEnd) + opacityEnd)
    .css(
      'transform',
      `scale(${scaler * (scaleStart - scaleEnd) +
        scaleEnd}) translate3d(0, ${scaler * (translateStart - translateEnd) +
        translateEnd}px, 0)`
    );
});



// WEBPACK FOOTER //
// ./assets/js/home.js